import { gql } from "@apollo/client";
import { Def_MutationResponse } from "../../UserCalls/GQLCalls/userCalls";
import { System } from "./getSystemCall";

export const CREATE_SYSTEM = gql`
  mutation Create($domain: String!, $type: Int!, $name: String!) {
    system {
      create(domain: $domain, type: $type, name: $name) {
        code
        success
        message
        updatedValues {
          system_id
          fk_system_types
          name
          feed_balance
          feed_balance_unit
          default_amount
          min_feed_speed
          max_feed_speed
          programmed
          system_attention_type(domain: $domain)
          image
        }
      }
    }
  }
`

export interface CreateSystemMutationResponse extends Def_MutationResponse {
  updatedValues?: [System]
}

export interface CreateSystemResponse {
  system: {
    create: CreateSystemMutationResponse;
  }
}